import { createEnum } from "@redotech/zod/zod-enum";
import * as zod from "zod/v4";

export enum BrightdataModel {
  CHATGPT = "chatgpt",
  GEMINI = "gemini",
  GOOGLE_AIMODE = "google_aimode",
  GROK = "grok",
  PERPLEXITY = "perplexity",
  COPILOT = "copilot",
}
export const BrightdataModelSchema = createEnum(BrightdataModel);

export const BRIGHTDATA_MODELS = Object.values(BrightdataModel);

export enum BrightdataRunStatus {
  PENDING = "pending",
  RUNNING = "running",
  COMPLETE = "complete",
  FAILED = "failed",
}
export const BrightdataRunStatusSchema = createEnum(BrightdataRunStatus);

const BrightdataModelStatus_ = zod.object({
  model: BrightdataModelSchema,
  status: BrightdataRunStatusSchema,
});
export const BrightdataModelStatusSchema: zod.ZodType<BrightdataModelStatus> =
  BrightdataModelStatus_;
export interface BrightdataModelStatus
  extends zod.infer<typeof BrightdataModelStatus_> {}
